<template>
  <div class="wait-environment-setup">
    <h3 class="mb-0">Aguarde alguns segundos enquanto preparamos seu ambiente!</h3>
    <BSpinner class="fa fa-circle-o-notch fa-spin" />
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue';

export default {
  components: { BSpinner },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables.scss';
@import '../../../sass/mixins.scss';

.wait-environment-setup {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;

  h3 {
    max-width: 26rem;
    text-align: center;
    @include salesflow-title($color: $salesflow-font-dark, $font-weight: 500);
    font-size: 20px;
    font-family: 'Inter';
  }

  span.fa-spin {
    color: $salesflow-primary;
    margin-bottom: 1rem;
  }
}

@media screen and (min-width: 744px) {
  h3 {
    font-size: 24px !important;
  }

}

@media (min-width: 744px) and (max-height: 540px) {
  h3 {
    font-size: 20px !important;
  }
}
</style>
